// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609282208/js/" + chunkId + "." + {"44":"2eb50e31","225":"0ea92683","481":"5ed70a00","486":"c926fd49","770":"1c907108"}[chunkId] + ".0.6408383967645909.chunk.js";
};